import React from 'react'

import {
  Paper,
  Box,
  Typography,
  Divider,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import EventIcon from '@material-ui/icons/EventOutlined'

import { Link, useParams } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'routes'

import moment from 'moment'
import useFetch from 'hooks/useFetch'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import ModalSuccess from 'components/ModalSuccess'

const ContractSuspended = ({ contract, onEvent = () => {} }) => {
  const params = useParams()
  const snackbar = useSnackbar()
  const [confirm, setConfirm] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const contractId = params.contractId

  const { response } = useFetch(service.recurrence.contractSchedules.list, {
    contractId,
    executed: false,
    type: 2,
  })

  const handleClose = () => {
    setOpen(false)
    onEvent()
  }

  const activate = async () => {
    setConfirm(false)
    try {
      await service.recurrence.contractSchedules.activate({
        contractId,
      })
      setOpen(true)
    } catch (error) {
      snackbar.open({
        message: 'Erro ao ativar assinatura!',
        variant: 'error',
      })
    }
  }

  return (
    <>
      <Paper>
        <Box p={2}>
          <Typography variant="h4">Reativar assinatura</Typography>
        </Box>
        <Divider />
        <Box p={2}>
          <Typography color="textSecondary">
            Esta assinatura está temporariamente suspensa.
          </Typography>
          <Typography color="textSecondary">
            Reative agora para voltar a fazer cobranças ou agende uma nova data
            para reativação
          </Typography>

          <Box display="flex" alignItems="center" mt={2}>
            <Box mr={1}>
              <EventIcon color="disabled" style={{ fontSize: '3rem' }} />
            </Box>
            <Box>
              <Typography component="div" color="textSecondary">
                <Box display="flex">
                  <Box mr={1 / 2}>Início da suspensão:</Box>
                  <Box fontWeight="fontWeightBold">
                    {moment(
                      contract.historyContractStatuses[
                        contract.historyContractStatuses.length - 1
                      ].createdAt,
                    ).format('DD/MM/YYYY')}
                  </Box>
                </Box>
              </Typography>
              <Typography component="div" color="textSecondary">
                <Box display="flex">
                  <Box mr={1 / 2}>Data agendada para reativação:</Box>
                  <Box fontWeight="fontWeightBold">
                    {response?.data.schedules
                      ? moment(response?.data.schedules[0].createIn).format(
                          'DD/MM/YYYY',
                        )
                      : 'Não informada'}
                  </Box>
                </Box>
              </Typography>
            </Box>
          </Box>

          <Box mt={2} maxWidth={900}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={3}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => setConfirm(true)}
                >
                  Reativar assinatura
                </Button>
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <Button
                  component={Link}
                  to={reverse(routes.contracts.suspend, {
                    contractId: params.contractId,
                  })}
                  color="primary"
                  variant="outlined"
                >
                  {response?.data.schedules
                    ? 'Reagendar ativação'
                    : 'Agendar reativação'}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Paper>

      <ModalSuccess open={open} onClose={handleClose}>
        Assinatura reativada
      </ModalSuccess>

      <Dialog open={confirm} onClose={() => setConfirm(false)}>
        <DialogTitle>Reativar assinatura</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente reativar esta assinatura agora? Ao confirmar a
            reativação, a cobrança de faturas será imediatamente retomada.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={() => activate()}
          >
            Reativar
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setConfirm(false)}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ContractSuspended
